<bizz-modal modalSize="xs" [headerTemplate]="headerTemplate"
            [contentTemplate]="contentTemplate"
            [footerTemplate]="footerTemplate"></bizz-modal>
<ng-template #headerTemplate>
</ng-template>

<ng-template #contentTemplate>
    <div class="modal-header">
        <bizz-alert type="warning" [message]="'ResultCheckDuplicateWarning' | translate" ></bizz-alert>
    </div>
</ng-template>

<ng-template #footerTemplate>
    <div class="modal-buttons">
        <div class="flex flex-row justify-end gap-4 text-center">
            <button class="default"
                    (click)="dialogRef.close()">
                {{ 'Cancel' | translate }}
            </button>
            <button class="save rounded-md"
                    (click)="dialogRef.close(true)">
                {{ 'Ok' | translate }}
            </button>
        </div>

    </div>
</ng-template>